import { PostIncident } from "./ApiCalls/incident/postIncident";

import { GetIncidentUser } from "./ApiCalls/incident/getIncidentUser";

import { GetIncidentsResponsible } from "./ApiCalls/incident/getIncidentsResponsible";

import { PostIncidentActivity } from "./ApiCalls/incident/postIncidentActivity";

import { PatchIncidentActivity } from "./ApiCalls/incident/patchIncidentActivity";

import { GetIncidentResponsible } from "./ApiCalls/incident/getIncidentResponsible";

import { formatToSpanishTimeZone } from "../utils/formatDate";

import { addDaysAndFormat } from "../utils/formatDate";

import { PatchIncident } from "./ApiCalls/incident/patchIncident";

import i18n from "i18next";

import { GetIncidentActivityTypes } from "./ApiCalls/incident/getIncidentActivityTypes";
import { GetIncidentsStadistics } from "./ApiCalls/incident/getIncidentsStadistics";
import { GetIncidentFindResponsible } from "./ApiCalls/incident/getIncidentFindResponsible";

const authInfoString = localStorage.getItem("authInfo");

const authInfo = authInfoString ? JSON.parse(authInfoString) : {};

const user = authInfo.idUser;

export async function PostIncidentService(incident) {
  try {
    const key = await PostIncident(incident);

    return key;
  } catch (error) {
    // console.error("Error during login:", error);

    // Manejar el error

    throw error;
  }
}

export async function GetIncidentUserService(key, company) {
  try {
    const incidents = await GetIncidentUser(key, company);
    if (!incidents) {
      return incidents;
    }

    const incidentData = incidents.map((inc) => {
      // Ordenar incidentActivities de más reciente a más antiguo

      const sortedActivities = inc.incidentActivities.sort((a, b) => {
        // Convertir las fechas a objetos Date para la comparación

        const dateA = new Date(a.incidentActivity.createdAt);

        const dateB = new Date(b.incidentActivity.createdAt);

        return dateB - dateA; // Orden descendente
      });

      const filteredActivities = sortedActivities.filter(
        (activity) =>
          activity.incidentActivityType.incidentActivityType1 !==
          "679c0a2c-db0b-4564-8e56-4ec87d7477f7"
      );

      return {

        audio: inc.incident.audio,

        incident: inc.incident.incident1,

        incidentKey: inc.incident.incidentKey,

        createdAt: inc.incident.createdAt,

        limitDateAd: addDaysAndFormat(inc.incident.createdAt, 7),

        limitDateRes: formatToSpanishTimeZone(inc.incident.limitDate),

        category: inc.incidentCategory.name,

        company: inc.company.company.name,

        workPlace: inc.incident.workPlaceName,

        companyId: inc.company.company.company1,

        companyFileName: inc.company.file.name,

        companyFileMimeType: inc.company.file.mimeType,

        companyFileData: inc.company.file.fileData,

        userName: inc.incident.userName
          ? inc.incident.userName
          : `${i18n.t("services:services.anonymous")}`,

        title: inc.incident.title,

        description: inc.incident.description,

        state: inc.incidentState.name,

        stateId: inc.incidentState.incidentState1,

        responsible: inc.incident.responsibleName,

        informantType: inc.incident.informantType
          ? inc.incident.informantType !== null
            ? inc.incident.informantType
            : "---"
          : "---",

        incidentDate: inc.incident.incidentDate
          ? inc.incident.incidentDate !== null
            ? formatToSpanishTimeZone(inc.incident.incidentDate)
            : "---"
          : "---",

        fileName: inc.incident.fileBody ? inc.incident.fileBody.name : null,

        fileMimeType: inc.incident.fileBody
          ? inc.incident.fileBody.mimeType
          : null,

        fileData: inc.incident.fileBody ? inc.incident.fileBody.fileData : null,

        customQuestions:
          inc.questionWithResponse.questions.length > 0
            ? inc.questionWithResponse.questions.map((question, index) => {
              return {
                question: question,
                response: inc.questionWithResponse.responses[index],
              };
            })
            : null,

        incidentActivities: filteredActivities.map((activity) => {
          return {
            incidentActivity: activity.incidentActivity.incidentActivity1,

            createdAt: activity.incidentActivity.createdAt,

            date: activity.incidentActivity.date
              ? activity.incidentActivity.date
              : null,

            title: activity.incidentActivity.title
              ? activity.incidentActivity.title
              : null,

            description: activity.incidentActivity.description
              ? activity.incidentActivity.description
              : null,

            incidentActivityType: activity.incidentActivityType.name,

            incidentActivityState: activity.incidentState
              ? activity.incidentState.name
              : null,

            incidentActivityStateId: activity.incidentState
              ? activity.incidentState.incidentState1
              : null,

            location: activity.incidentActivity.location
              ? activity.incidentActivity.location
              : null,

            participants: activity.incidentActivity.participants
              ? activity.incidentActivity.participants
              : null,

            fileName: activity.incidentActivity.fileBody
              ? activity.incidentActivity.fileBody.name
              : null,

            fileMimeType: activity.incidentActivity.fileBody
              ? activity.incidentActivity.fileBody.mimeType
              : null,

            fileData: activity.incidentActivity.fileBody
              ? activity.incidentActivity.fileBody.fileData
              : null,
          };
        }),
      };
    });
    return incidentData;
  } catch (error) {
    // Manejar el error

    throw error;
  }
}

export async function GetIncidentResponsibleService(incident) {
  try {
    const incidents = await GetIncidentResponsible(incident, user);

    const incidentData = incidents.map((inc) => {
      // Ordenar incidentActivities de más reciente a más antiguo
      const sortedActivities = inc.incidentActivities.sort((a, b) => {
        // Convertir las fechas a objetos Date para la comparación

        const dateA = new Date(a.incidentActivity.createdAt);

        const dateB = new Date(b.incidentActivity.createdAt);

        return dateB - dateA; // Orden descendente
      });

      const filteredActivities = sortedActivities.filter(
        (activity) =>
          activity.incidentActivityType.incidentActivityType1 !==
          "5f1ee1ad-a36c-4ea7-b591-cdbe347c2f8a"
      );

      return {
        audio: inc.incident.audio,

        incident: inc.incident.incident1,

        incidentKey: inc.incident.incidentKey,

        createdAt: formatToSpanishTimeZone(inc.incident.createdAt),

        limitDateAd: addDaysAndFormat(inc.incident.createdAt, 7),

        limitDateRes: formatToSpanishTimeZone(inc.incident.limitDate),

        category: inc.incidentCategory.name,

        company: inc.company.company.name,

        workPlace: inc.incident.workPlaceName,

        companyId: inc.company.company.company1,

        companyFileName: inc.company.file.name,

        companyFileMimeType: inc.company.file.mimeType,

        companyFileData: inc.company.file.fileData,

        userName: inc.incident.userName
          ? inc.incident.userName
          : `${i18n.t("services:services.anonymous")}`,

        title: inc.incident.title,

        description: inc.incident.description,

        state: inc.incidentState.name,

        stateId: inc.incidentState.incidentState1,

        responsible: inc.incident.responsibleName,

        informantType: inc.incident.informantType
          ? inc.incident.informantType !== null
            ? inc.incident.informantType
            : "---"
          : "---",

        incidentDate: inc.incident.incidentDate
          ? inc.incident.incidentDate !== null
            ? formatToSpanishTimeZone(inc.incident.incidentDate, true)
            : "---"
          : "---",

        fileName: inc.incident.fileBody ? inc.incident.fileBody.name : null,

        fileMimeType: inc.incident.fileBody
          ? inc.incident.fileBody.mimeType
          : null,

        fileData: inc.incident.fileBody ? inc.incident.fileBody.fileData : null,

        customQuestions:
          inc.questionWithResponse.questions.length > 0
            ? inc.questionWithResponse.questions.map((question, index) => {
              return {
                question: question,
                response: inc.questionWithResponse.responses[index],
              };
            })
            : null,

        incidentActivities: filteredActivities.map((activity) => {
          return {
            incidentActivity: activity.incidentActivity.incidentActivity1,

            createdAt: activity.incidentActivity.createdAt,

            date: activity.incidentActivity.date
              ? activity.incidentActivity.date
              : null,

            title: activity.incidentActivity.title
              ? activity.incidentActivity.title
              : null,

            description: activity.incidentActivity.description
              ? activity.incidentActivity.description
              : null,

            incidentActivityType: activity.incidentActivityType.name,

            incidentActivityState: activity.incidentState
              ? activity.incidentState.name
              : null,

            incidentActivityStateId: activity.incidentState
              ? activity.incidentState.incidentState1
              : null,

            location: activity.incidentActivity.location
              ? activity.incidentActivity.location
              : null,

            participants: activity.incidentActivity.participants
              ? activity.incidentActivity.participants
              : null,

            fileName: activity.incidentActivity.fileBody
              ? activity.incidentActivity.fileBody.name
              : null,

            fileMimeType: activity.incidentActivity.fileBody
              ? activity.incidentActivity.fileBody.mimeType
              : null,

            fileData: activity.incidentActivity.fileBody
              ? activity.incidentActivity.fileBody.fileData
              : null,
          };
        }),
      };
    });
    return incidentData;
  } catch (error) {
    // Manejar el error

    throw error;
  }
}

export async function GetIncidentsUResponsibleService() {
  try {
    const incidents = await GetIncidentsResponsible(user);

    const sortedIncidents = incidents.sort((a, b) => {
      // Convertir las fechas a objetos Date para la comparación

      const dateA = new Date(a.incident.createdAt);

      const dateB = new Date(b.incident.createdAt);

      return dateB - dateA; // Orden descendente
    });

    const incidentData = sortedIncidents.map((inc) => {
      return {
        incident: inc.incident.incident1,

        incidentKey: inc.incident.incidentKey,

        createdAt: inc.incident.createdAt,

        limitDateAd: addDaysAndFormat(inc.incident.createdAt, 7),

        limitDateRes: formatToSpanishTimeZone(inc.incident.limitDate),

        remainingDays: inc.incident.remainingDays,

        category: inc.incidentCategory.name,

        company: inc.company.company.name,

        workPlace: inc.incident.workPlaceName,

        companyId: inc.company.company.company1,

        //companyFileName: inc.company.file.name,

        //companyFileMimeType: inc.company.file.mimeType,

        //companyFileData: inc.company.file.fileData,

        username: inc.incident.username ? inc.incident.username : null,

        title: inc.incident.title,

        description: inc.incident.description,

        state: inc.incidentState.name,

        responsible: inc.incident.responsibleName,

        activityNumber: inc.activityNumber,

        incidentCategories: inc.incidentCategories,
      };
    });

    return incidentData;
  } catch (error) {
    // Manejar el error

    throw error;
  }
}

export async function PostIncidentActivitySrvice(
  incidentActivity,

  incidentActivityTypeName
) {
  try {
    const response = await PostIncidentActivity(
      incidentActivity,

      incidentActivityTypeName
    );

    return {
      userKey: response.incidentBody.userKey,
      company: response.incidentBody.company,
    };
  } catch (error) {
    // console.error("Error during login:", error);

    // Manejar el error

    throw error;
  }
}

export async function PatchIncidentService(idIncident) {
  const incident = await PatchIncident(idIncident);

  return incident;
}

export async function PatchIncidentActivityService(
  reply,

  idIncidentactivity,

  activityType
) {
  try {
    const response = await PatchIncidentActivity(
      reply,

      idIncidentactivity,

      activityType
    );

    return {
      userKey: response.incidentBody.userKey,
      company: response.incidentBody.company,
    };
  } catch (error) {
    // console.error("Error during login:", error);

    // Manejar el error

    throw error;
  }
}

export async function GetIncidentActivityTypesService() {
  try {
    const ActivityTypes = await GetIncidentActivityTypes();

    const ActivityTypesData = ActivityTypes.map((activity) => activity.name);

    return ActivityTypesData;
  } catch (error) {
    // console.error("Error during login:", error);
    // Manejar el error
    throw error;
  }
}

export async function GetIncidentsStadisticsService() {
  try {
    const incidents = await GetIncidentsStadistics(user);
    return incidents;
  } catch (error) {
    console.error("Error: ", error);
  }
}

export async function GetIncidentFindResponsibleService(company, category, workplace) {
  try {
    const incidents = await GetIncidentFindResponsible({ company, category, workplace });
    return incidents;
  } catch (error) {
    console.error("Error: ", error);
  }
}
